<template>
    <v-app>
        <v-container fluid>
        <v-row>
            <v-col>

                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" small v-if="showAllLeads === false" @click="showAllLeads = true">Afficher les Cloturés</v-btn>
                        <v-btn color="primary" small v-if="showAllLeads === true" @click="showAllLeads = false">Masquer les Cloturés</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                                dense
                                :headers="headers"
                                :items="leads"
                                :expanded="expandedLeads"
                                item-key="id"
                                class="elevation-1"
                                :items-per-page=100
                                show-expand
                                single-expand
                        >
                            <template v-slot:item="{ item, expand, isExpanded }" >
                                <tr :class="itemRowBackground(item)">
                                    <td><button @click="expand(!isExpanded)" type="button" class="v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light"></button></td>
                                    <td class="text-left">{{item.computed.datecreation}}</td>
                                    <td class="text-center">
                                        <v-icon v-if="item.prospect == 1" color="yellow lighten-3">mdi-star</v-icon>
                                    </td>
                                    <td class="text-left">{{item.name}}</td>
                                    <td class="text-left">{{item.rdvhistory[0].action}}</td>

                                    <td class="text-left">{{item.rdvhistory[0].frdate}}</td>
                                    <td class="text-left">{{item.rdvhistory[0].agendastatus}}</td>
                                </tr>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length" style="background-color: gainsboro">
                                    <v-row v-if="item.finalstatus == 'todo'" >
                                        <v-col
                                                align="start"
                                                class="text-left"
                                        >
                                            <v-btn
                                                    color="primary"
                                                    dark
                                                    @click="openNewCall(item)"
                                                    small
                                                    class="mr-2 mt-2 mb-2"
                                            >
                                                <v-icon left>mdi-cellphone</v-icon>
                                                Faire un appel
                                            </v-btn>
                                            <v-btn
                                                    color="primary"
                                                    dark
                                                    @click="openNewAction(item)"
                                                    small
                                                    class="mt-2 mb-2"
                                            >
                                                <v-icon left>mdi-alarm-multiple</v-icon>
                                                Programmer une action
                                            </v-btn>
                                        </v-col>

                                        <v-col v-if="item.prospect == 0">
                                            <v-btn
                                                    color="success"
                                                    dark
                                                    @click="openTransformProspect(item)"
                                                    small
                                                    class="mt-2 mb-2"
                                            >
                                                <v-icon left>mdi-account-star-outline</v-icon>
                                                Transformer en prospect à suivre !
                                            </v-btn>
                                        </v-col>

                                        <v-col
                                                align="end"
                                                class="text-right"
                                        >
                                            <v-btn
                                                    color="success"
                                                    dark
                                                    small
                                                    class="mr-2 mt-2 mb-2"
                                                    @click="openValideFinal(item)"
                                            >
                                                Vendu !
                                            </v-btn>
                                            <v-btn
                                                    color="error"
                                                    dark
                                                    small
                                                    @click="openPerteFinal(item)"
                                                    class="mt-2 mb-2"
                                            >
                                                Perdu :(
                                            </v-btn>
                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col class="text-left">
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-cellphone</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    {{ item.gsm }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-at</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    {{ item.mail }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-cash-usd-outline</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    {{ item.customdata.budgetclient }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-emoticon-happy-outline</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    {{ item.customdata.interetclient }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-comment-text-outline</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    {{ item.customdata.commentaireclient }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-cart-outline</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    {{ item.customdata.typeachatclient }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="1">
                                                    <v-icon>mdi-car</v-icon>
                                                </v-col>
                                                <v-col cols="9">
                                                    <span v-for="modele in modeleInterresse(item.customdata.modelsclient)" :key="modele.name">{{ modele.name}}, </span>
                                                </v-col>
                                            </v-row>

                                        </v-col>
                                        <v-col class="text-left">
                                            <v-timeline :reverse="reverse" dense>
                                                <v-timeline-item
                                                        v-for="history in item.rdvhistory"
                                                        :key="history.date"
                                                        class="mb-0 mt-0 pt-0 pb-0"
                                                        :icon="history.icon"
                                                >
                                                  <v-sheet
                                                      elevation="6"
                                                      class="mt-2 mb-2 pa-2"
                                                      :color="history.agendastatus == 'todo' ? '#ffecb3':''"
                                                  >
                                                    <v-row>
                                                        <v-col class="pt-0 pb-0" :cols="history.agendastatus == 'todo'?'8':'12'">
                                                            <h4>
                                                                Le {{ history.frdate}} à {{ history.frheure }} : {{ history.action }}
                                                            </h4>
                                                        </v-col>
                                                        <v-col class="text-right pt-0 pb-0">
                                                            <v-btn
                                                                    v-if="history.agendastatus == 'todo'"
                                                                    x-small
                                                                    color="primary"
                                                                    @click="openRetourAgenda(item, history)"
                                                            >
                                                                Faire un retour
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row >
                                                      <v-col class="pt-0 pb-0">

                                                          <p class="mt-0 pb-0">
                                                          <p>
                                                            <span class="font-weight-light">{{ history.comment }}</span>
                                                          </p>
                                                          <v-row >
                                                            <v-col cols="1" class="text-center pt-0 pb-0">
                                                              <v-icon color="green" title="Le retour client est positif" large v-if="history.hsalesagenda.customdata.retour.retourEvaluation == 'Positif'">mdi-emoticon-happy-outline</v-icon>
                                                              <v-icon color="red" title="Le retour client est négatif" large v-if="history.hsalesagenda.customdata.retour.retourEvaluation == 'Négatif'">mdi-emoticon-sad-outline</v-icon>
                                                              <v-icon color="orange" large v-if="history.hsalesagenda.customdata.retour.retourEvaluation == 'Je ne sais pas'">mdi-emoticon-neutral-outline</v-icon>
                                                            </v-col>
                                                            <v-col cols="1" class="text-center pt-0 pb-0">
                                                              <v-icon color="green" title="J'ai effectué l'action" large v-if="history.hsalesagenda.customdata.retour.retourStatus == 'Effectué'">mdi-account-check-outline</v-icon>
                                                              <v-icon color="orange" title="Le client est injoignable ou absent" large v-if="history.hsalesagenda.customdata.retour.retourStatus == 'Client injoignable ou absent'">mdi-account-search-outline</v-icon>
                                                              <v-icon color="red" title="J'ai oublié de faire l'action" large v-if="history.hsalesagenda.customdata.retour.retourStatus == 'Oublie'">mdi-account-alert-outline</v-icon>
                                                            </v-col>
                                                            <v-col class="pt-0 pb-0" >
                                                              <p style="line-height: 2.5em">{{ history.hsalesagenda.customdata.retour.retourCommentaire }}</p>
                                                            </v-col>
                                                          </v-row>
                                                      </v-col>
                                                    </v-row>
                                                  </v-sheet>
                                                </v-timeline-item>
                                            </v-timeline>

                                        </v-col>
                                    </v-row>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-dialog v-model="dialog" persistent max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Nouvel Appel</span>
                        </v-card-title>
                        <v-card-text class="text-left">
                            <v-row>
                                <v-col cols="12">
                                    <strong>Nom : </strong>{{ actualRdv.name}}<br>
                                    <strong>Modèle : </strong>
                                    <span v-for="model in modeleInterresse(actualRdv.customdata.modelsclient)" :key="model.name">
                                            {{ model.name }}
                                        </span>
                                    <strong>Budget : </strong>{{ actualRdv.customdata.budgetclient}}
                                </v-col>
                            </v-row>
                            <v-textarea
                                    outlined
                                    name="input-7-4"
                                    label="Commentaire sur votre appel (obligatoire)"
                                    value=""
                                    v-model="commentNewCall"
                            ></v-textarea>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialog = false">Annuler</v-btn>
                            <v-btn color="blue darken-1" text @click="saveCall()">Enregistrer</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogNewProspect" max-width="350">
                    <v-card>
                        <v-card-title class="headline">Un nouveau prospect ?</v-card-title>

                        <v-card-text class="text-left">
                            Transformer un contact en prospect vous permet de plus facilement visualiser les clients qui ont un véritable potentiel d'acheteur.
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                    color="red darken-1"
                                    text
                                    @click="dialogNewProspect = false"
                            >
                                Annuler
                            </v-btn>

                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="transformToProspect()"
                            >
                                Créer le prospect
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogNewAction" persistent max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Programmer une action</span>
                        </v-card-title>
                        <v-card-text class="text-left">
                            <v-row >
                                <v-col cols="12" class="mb-0 pb-0">
                                    <strong>Nom : </strong>{{ actualRdv.name}}<br>
                                    <strong>Modèle : </strong>
                                    <span v-for="model in modeleInterresse(actualRdv.customdata.modelsclient)" :key="model.name">
                                            {{ model.name }}
                                        </span>
                                    <strong>Budget : </strong>{{ actualRdv.customdata.budgetclient}}
                                </v-col>
                            </v-row>
                            <v-row class="mb-0 pb-0">
                                <v-col class="text-left mb-0 pb-0">
                                    <v-select
                                            :items="listActions"
                                            label="Quelle action ?"
                                            dense
                                            outlined
                                            text-left
                                            full-width
                                            class="mb-0 pb-0"
                                            v-model="newAgendaType"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="mt-0 pt-0">
                                    <v-menu
                                            v-model="dialogDateAction"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="computedAgendaDate"
                                                    label="Date"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="newAgendaDate" no-title @input="dialogDateAction = false"></v-date-picker>
                                    </v-menu>
                                    <v-dialog
                                            ref="dialog"
                                            v-model="dialogHeureAction"
                                            persistent
                                            width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="newAgendaHeure"
                                                    label="Heure"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                                v-if="dialogHeureAction"
                                                v-model="newAgendaHeure"
                                                full-width
                                                format="24hr"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="dialogHeureAction = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="dialogHeureAction = false">OK</v-btn>
                                        </v-time-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col cols="6">
                                    <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="Commentaire"
                                            value=""
                                            v-model="newAgendaTodoComment"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialogNewAction = false">Annuler</v-btn>
                            <v-btn color="blue darken-1" text @click="saveNewAgenda()">Enregistrer</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogRetourAgenda" persistent max-width="800px">
                    <v-card>
                        <v-card-text class="text-left">
                            <v-row >
                                <v-col cols="12" class="mb-0 pb-0">
                                    <v-sheet elevation="2" width="100%" class="pa-3">
                                        <strong>Nom : </strong>{{ actualRdv.name}}<br>
                                        <strong>Modèle : </strong>
                                        <span v-for="model in modeleInterresse(actualRdv.customdata.modelsclient)" :key="model.name">
                                            {{ model.name }}
                                        </span>
                                        <br>
                                        <strong>Budget : </strong>{{ actualRdv.customdata.budgetclient}}
                                    </v-sheet>

                                </v-col>
                            </v-row>
                            <v-row v-if="actualHistoryElement">
                                <v-col cols="12" class="mb-0 pb-0">
                                    <v-sheet elevation="2" width="100%" class="pa-3">
                                        <v-icon>{{ actualHistoryElement.icon }}</v-icon>
                                        <span class="ml-2">{{ actualHistoryElement.action }}</span>
                                        <br>
                                        <v-icon>mdi-account</v-icon>
                                        <span class="ml-2">{{ actualHistoryElement.comment }}</span>
                                    </v-sheet>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="pb-0 mb-0">
                                    <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="Commentaire sur l'action effectuée"
                                            value=""
                                            v-model="retourAgendaComment"
                                            dense
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col cols="12" sm="6" class="pt-0 pb-0 mt-0 mb-0">
                                    <v-select
                                            :items="retourAgendaStatus"
                                            label="Status de l'action"
                                            outlined
                                            full-width
                                            v-model="retourAgentAgendaStatus"
                                            dense
                                    >
                                    </v-select>
                                </v-col>
                                <v-col cols="12" sm="6" class="pt-0 pb-0 mt-0 mb-0">
                                    <v-select
                                            :items="retourAgendaEvaluation"
                                            label="Le résultat est plutôt"
                                            outlined
                                            full-width
                                            v-model="retourAgendaAgentEvaluation"
                                            dense
                                    ></v-select>
                                </v-col>
                            </v-row>

                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialogRetourAgenda = false">Annuler</v-btn>
                            <v-btn color="blue darken-1" text @click="saveRetourAgenda()">Enregistrer</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogValideVente" max-width="290">
                    <v-card>
                        <v-card-title class="headline text-center">C'est une vente ?</v-card-title>

                        <v-card-text class="text-left">
                            Vous allez indiqué que ce prospect est une vente. <br>Une fois validé il disparaîtra de votre liste et vous ne pourrez plus revenir sur celui-ci.
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="validFinalStatus(true)"
                            >
                                Oui
                            </v-btn>

                            <v-btn
                                    color="red darken-1"
                                    text
                                    @click="dialogValideVente = false"
                            >
                                Non
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogValidePerte" max-width="290">
                    <v-card>
                        <v-card-title class="headline text-center">La vente est perdue ?</v-card-title>

                        <v-card-text class="text-left">
                            Vous allez indiqué que ce prospect ne sera pas une vente. <br>Une fois validé il disparaîtra de votre liste et vous ne pourrez plus revenir sur celui-ci.
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                    color="green darken-1"
                                    text
                                    @click="validFinalStatus(false)"
                            >
                                Oui
                            </v-btn>

                            <v-btn
                                    color="red darken-1"
                                    text
                                    @click="dialogValidePerte = false"
                            >
                                Non
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        </v-container>

    </v-app>

</template>

<script>
    import NProgress from "nprogress";

    export default {
        name: "ListeConnectHistory",
        data() {
            return {
                reverse : false,
                showAllLeads : false,
                retourAgendaComment: '',
                retourAgentAgendaStatus: '',
                retourAgendaAgentEvaluation: '',
                newAgendaType: '',
                newAgendaHeure: '',
                newAgendaTodoComment: '',
                newAgendaDate: new Date().toISOString().substr(0, 10),
                dialog: false,
                dialogNewProspect: false,
                dialogNewAction: false,
                dialogDateAction: false,
                dialogHeureAction: false,
                dialogValideVente: false,
                dialogValidePerte: false,
                dialogRetourAgenda: false,
                dateAction:'',
                heureAction:'',
                loading: false,
                unauthorized: false,
                listActions: ['Test Drive','Appel','Rendez-vous','Mail','Rappel'],
                retourAgendaStatus: ['Effectué','Client injoignable ou absent','Oublie'],
                retourAgendaEvaluation: ['Positif','Négatif','Je ne sais pas'],
                actualRdv: {
                    customdata: {
                        modelsclient : []
                    },
                    rdvhistory: []
                },
                actualHistoryElement: null,
                commentNewCall: '',
                headers: [
                  {
                    text: 'Date Création',
                    value: 'computed.datecreation'
                  },
                    {
                        text: 'Prospect',
                        align: 'center',
                        sortable: true,
                        value: 'prospect'
                    },
                    {
                        text: 'Nom',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {
                        text: 'Prochaine action',
                        value: 'customdata.prochaineactionclient'
                    },
                    {
                        text: 'Dernière interaction',
                        value: 'computed.lastactivitydate'
                    },
                    {
                        text: 'Status',
                        value: 'customdata.statusappel'
                    },
                ],
                rdvs: [],
                expandedLeads: []
            }
        },
        methods: {
            saveRetourAgenda(){
                if(this.retourAgendaComment == ''){
                  alert('Veuillez indiquer un commentaire à votre retour')
                  return false
                }
                if(this.retourAgentAgendaStatus == ''){
                  alert('Veuillez indiquer un status à votre retour')
                  return false
                }
                if(this.retourAgendaAgentEvaluation == ''){
                  alert('Veuillez indiquer une évalusation pour votre interaction')
                  return false
                }
                let params = {}
                params.action = 'saveRetourAction'
                params.agendaid = this.actualHistoryElement.agendaid
                params.rdvid = this.actualRdv.id
                params.retour = {
                    "retourCommentaire": this.retourAgendaComment,
                    "retourStatus" : this.retourAgentAgendaStatus,
                    "retourEvaluation" : this.retourAgendaAgentEvaluation
                }
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then(data => {
                        console.log(data.data)
                        if(data.data.error === true){
                            console.log('Error');
                            return false;
                        }

                        this.loadData();
                        this.dialogRetourAgenda = false
                    })
                .catch(error => {
                    console.log(error)
                })
            },
            validFinalStatus(status){
                let params = {}
                params.status = status
                params.id = this.actualRdv.id
                params.action = 'validFinalStatus'
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            // TODO : Afficher erreur dans modal
                            return false
                        }
                        this.getRdv()
                        this.dialogValidePerte = false
                        this.dialogValideVente = false
                        // TODO : Afficher erreur dans modal
                    })
                    .catch( error => {
                        console.log(error);
                        // TODO : Afficher erreur dans modal
                    })
            },
            loadData() {
                // TODO : Voir pour stocker les 30 derniers jours dans VueX
                let params = {}
                params.action = 'getLast30DaysConnect'
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            NProgress.done()
                            return false
                        }
                        this.rdvs = data.data.data
                        this.rdvs.forEach(element => {
                            if(this.rdvid !== undefined && this.agendaid !== undefined && this.rdvid === element.id){
                                element.rdvhistory.forEach(obj => {
                                    if(obj.agendaid !== undefined && obj.agendaid == this.agendaid){
                                        if(obj.agendastatus == 'todo'){
                                            this.openRetourAgenda(element,obj)
                                        }
                                    }
                                })
                                if(element.finalstatus == 'Vendu' || element.finalstatus == 'Perdu') {
                                  this.showAllLeads = true
                                }
                                this.expandedLeads.push(element)


                            }
                            element.rdvhistory.reverse()
                        })
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        NProgress.done()
                    })
            },
            modeleInterresse(modeles) {
               //return modeles.filter(modele => modele.selection === true)
              return modeles
            },
            openNewCall(rdv){
                this.actualRdv = rdv
                this.dialog = true
            },
            openNewAction(rdv){
                this.actualRdv = rdv
                this.dialogNewAction = true
            },
            openValideFinal(rdv){
                this.actualRdv = rdv
                this.dialogValideVente = true
            },
            openPerteFinal(rdv){
                this.actualRdv = rdv
                this.dialogValidePerte = true
            },
            openTransformProspect(rdv){
                this.actualRdv = rdv
                this.dialogNewProspect = true
            },
            openRetourAgenda(rdv, historydetails){
                this.actualRdv = rdv
                this.actualHistoryElement = historydetails
                this.dialogRetourAgenda = true
                this.retourAgendaComment = ''
                this.retourAgentAgendaStatus = ''
                this.retourAgendaAgentEvaluation = ''
            },
            saveCall(){
                let params = {}
                params.action = 'saveNewConnectCall'
                params.comment = this.commentNewCall
                params.id = this.actualRdv.id

                if(params.comment == ''){
                  alert('Veuillez saisir un commentaire pour votre appel.')
                  return false
                }
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            // TODO : Afficher erreur dans modal
                            return false
                        }
                        this.getRdv()
                        this.dialog = false
                        // TODO : Afficher erreur dans modal
                    })
                    .catch( error => {
                        console.log(error);
                        // TODO : Afficher erreur dans modal
                    })

            },
            getRdv(){
                NProgress.start()
                this.loading = true
                let params = {}

                params.action = 'viewRdv'
                params.id = this.actualRdv.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data.data.data)
                        if(data.data.error === true){
                            if(data.data.data == 'Unauthorized'){
                                this.unauthorized = true
                            }
                            // TODO : faire une snackbar
                            NProgress.done()
                            return false
                        }

                        this.actualRdv = data.data.data
                        this.loadData()
                        this.commentNewCall = ''
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            transformToProspect(){
                NProgress.start()
                this.loading = true
                let params = {}

                params.action = 'transformToProspect'
                params.id = this.actualRdv.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.data.error === true){
                            if(data.data.data == 'Unauthorized'){
                                this.unauthorized = true
                            }
                            // TODO : faire une snackbar
                            this.dialogNewProspect = false
                            NProgress.done()
                            return false
                        }
                        this.dialogNewProspect = false
                        this.loadData()
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            saveNewAgenda(){

                let params = {}
                params.action = 'saveAgenda'
                params.dateagenda = this.newAgendaDate;
                params.heureagenda = this.newAgendaHeure;
                params.type = this.newAgendaType
                params.todocomment = this.newAgendaTodoComment;
                params.hconnectrdvid = this.actualRdv.id;

                if(params.heureagenda == ''){
                  alert('Veuillez sélectionner une heure pour votre agenda')
                  return false
                }
                if(params.type == ''){
                  alert('Veuillez sélectionner une action pour votre agenda ')
                  return false
                }

                this.axios
                    .post(this.$store.state.rootUrl+'apiSalesNew.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            // TODO : Afficher erreur dans modal
                            this.dialogNewAction = false
                            return false
                        }
                        this.getRdv()
                        this.dialogNewAction = false
                        this.newAgendaDate = ''
                        this.newAgendaHeure = ''
                        this.newAgendaType = ''
                        this.newAgendaTodoComment = ''

                        // TODO : Afficher erreur dans modal
                    })
                    .catch( error => {
                        console.log(error);
                        this.dialogNewAction = false
                        // TODO : Afficher erreur dans modal
                    })
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            itemRowBackground: function (item) {
                if(item.finalstatus === 'Vendu'){
                    return 'green'
                }
                if(item.finalstatus === 'Perdu'){
                    return 'red'
                }
                return ''
            }
        },
        mounted() {
            this.loadData()
        },
        computed: {
            computedAgendaDate () {
                return this.formatDate(this.newAgendaDate)
            },
            leads() {
                let data = []
                if(this.showAllLeads === false){
                    this.rdvs.forEach(element => {
                        if(element.finalstatus === 'todo'){
                            data.push(element)
                        }
                    })
                }else{
                    data = this.rdvs
                }
                return data
            }
        },
        props: ['rdvid','agendaid']
    }
</script>

<style>
    .v-data-table tbody tr.v-data-table__expanded__content {
        box-shadow: 0;
        background-color: aliceblue;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }
    .style-1 {
        background-color: rgb(215,215,44)
    }
    .style-2 {
        background-color: rgb(114,114,67)
    }
    .style-todo {
        background-color: #ffecb3;
    }
</style>
